import React, {useEffect} from 'react';
import CrewCartMember from "./CrewCartMember.jsx";

const Header = ({ crewCart }) => {
    useEffect(() => {
        
    }, [crewCart]);

    return (
        <>
            <style>
                {`
                .header-container {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    padding: 10px 0;
                }

                .crewcart-members {
                    display: flex;
                    margin-left: -15px; /* Creates the overlap effect */
                }

                .crewcart-logo {
                    width: 100px;
                }

                .crewcart-members > * {
                    margin-left: -5px; /* Overlap for CrewCartMember components */
                }
                `}
            </style>

            <div className="header-container">
                <img src="/images/crewcart.png" className="crewcart-logo" />
                <div className="crewcart-members">
                    {crewCart?.members?.map((member, index) => (
                        <CrewCartMember
                            key={index}
                            name={member.name}
                            status={member.status}
                            size={35}
                        />
                    ))}
                </div>
            </div>
            <div className="bottom-border"></div>
        </>
    );
}

export default Header;
